export default {
    methods: {
        qtdeCasasDecimais(quantidadeCasasDecimais) {
            if ((quantidadeCasasDecimais === null || quantidadeCasasDecimais === undefined) || quantidadeCasasDecimais <= 0) {
                return 1
            }
            return quantidadeCasasDecimais
        }
    }
}